import { Minus, Plus } from "lucide-react";
import { SeasonalTag } from "@/components/SeasonalTag";

const tid = (f) => f.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const mixText = (mix) =>
  Object.entries(mix).filter(([, n]) => n > 0).map(([f, n]) => `${n}× ${f}`).join(", ");

export const MixPicker = ({ flavors, details, seasonal, size, mix, setMix, onFocus }) => {
  const total = Object.values(mix).reduce((s, n) => s + n, 0);
  const change = (f, d) => {
    const next = (mix[f] || 0) + d;
    if (next < 0 || (d > 0 && total >= size)) return;
    setMix({ ...mix, [f]: next });
    if (d > 0) onFocus?.(details?.[f]?.img);
  };
  return (
    <div data-testid="mix-picker">
      <div className="flex items-baseline justify-between mb-3">
        <p className="eyebrow">Build your box</p>
        <p data-testid="mix-count" className={`text-sm ${total === size ? "text-espresso" : "text-mocha"}`}>{total} of {size} chosen</p>
      </div>
      <div className="h-px bg-espresso/15 relative mb-2">
        <span className="absolute left-0 top-0 h-px bg-gold transition-[width] duration-500" style={{ width: `${(total / size) * 100}%` }} />
      </div>
      <ul>
        {flavors.map((f) => (
          <li key={f} className="flex items-center justify-between py-3 border-b border-espresso/10">
            <span className="flex items-center gap-3 min-w-0">
              {details?.[f]?.img && <img src={details[f].img} alt="" className="w-9 h-9 rounded-full object-cover bg-[#F1EDE4] shrink-0" />}
              <span className="flex flex-col items-start gap-0.5">
                <span className={`text-sm ${mix[f] ? "text-espresso" : "text-mocha"}`}>{f}</span>
                {seasonal?.includes(f) && <SeasonalTag testId={`mix-seasonal-${tid(f)}`} />}
              </span>
            </span>
            <span className="flex items-center gap-1">
              <button type="button" data-testid={`mix-dec-${tid(f)}`} onClick={() => change(f, -1)} disabled={!mix[f]} aria-label={`Remove ${f}`}
                className="w-8 h-8 rounded-full border border-espresso/20 flex items-center justify-center disabled:opacity-30 hover:border-espresso transition-colors">
                <Minus className="w-3 h-3" />
              </button>
              <span data-testid={`mix-qty-${tid(f)}`} className="w-8 text-center text-sm">{mix[f] || 0}</span>
              <button type="button" data-testid={`mix-inc-${tid(f)}`} onClick={() => change(f, 1)} disabled={total >= size} aria-label={`Add ${f}`}
                className="w-8 h-8 rounded-full border border-espresso/20 flex items-center justify-center disabled:opacity-30 hover:border-espresso transition-colors">
                <Plus className="w-3 h-3" />
              </button>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
